export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=73854bc9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/Index.vue?vue&type=template&id=73854bc9&scoped=true
// module id = 1703
// module chunks = 31